import { Base } from '../base/index.js';

/**
 * Component's name.
 * @type {string}
 */
export const name = 'search';

/**
 * Class Search.
 */
export class Search extends Base {
  /**
   * @type {import('../../types.d.ts').BaseConfig}
   */
  static config = {
    name,
  };

  connectedCallback() {
    this.isOpen = false;
    this.getElements();
  }

  /**
   * getElements
   */
  getElements() {
    /** @type {HTMLButtonElement} */
    this.btn = this.querySelector('.search-open-btn');
    /** @type {HTMLInputElement} */
    this.input = this.querySelector('.input-search');

    this.btn.addEventListener('click', this.onBtnClick.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
  }

  /**
   *onBtnClick
   */
  onBtnClick() {
    if (this.isOpen) {
      return this.close();
    }

    return this.open();
  }

  /**
   * close
   */
  close() {
    this.classList.remove('is-open');
    this.isOpen = false;
  }

  /**
   * open
   */
  open() {
    this.classList.add('is-open');
    this.input.focus();
    this.isOpen = true;

    document.addEventListener('click', this.onClickOutside.bind(this));
  }

  /**
   * on Click Outside
   * @param {object} event
   * @param {*} event.target
   */
  onClickOutside({ target }) {
    if (!this.contains(target)) {
      this.close();
    }
    document.removeEventListener('click', this.onClickOutside);
  }

  /**
   * @param {object} event
   * @param {String} event.key
   */
  onKeyup({ key }) {
    if (this.isOpen && key === 'Escape') {
      this.close();
    }
  }
}

export default Search;
